// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"5ba88097","453":"1f60fced"}[chunkId] + ".chunk.js";
};